import { Text, View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import type { SubheaderRowProps } from '../../../../../types/reportSection'
import { HeaderCellStyles } from '../../../styles/HeaderCellStyles'

type ColumnLabelsProps = {
  labels: string[]
}

const ColumnLabels = ({ labels }: ColumnLabelsProps) => {
  if (!labels.length) {
    return <View style={HeaderCellStyles.columnLabelsCell} />
  }

  return (
    <View style={HeaderCellStyles.columnLabelsCell}>
      {labels.map((label, idx) => (
        <View key={`${idx}-${label}`} style={HeaderCellStyles.columnLabelSlot}>
          <Text style={commonPdfTableStyles.subHeaderText}>{label}</Text>
        </View>
      ))}
    </View>
  )
}

export const SubheaderRow = ({ leftText, labels, reserveSymbolColumn }: SubheaderRowProps) => {
  return (
    <View style={[commonPdfTableStyles.row, commonPdfTableStyles.subHeaderRow]}>
      {reserveSymbolColumn && (
        <View style={HeaderCellStyles.symbolCell}>
          <Text style={commonPdfTableStyles.subHeaderText}>{'\u00a0'}</Text>
        </View>
      )}
      <View style={HeaderCellStyles.subSectionCell}>
        <Text style={commonPdfTableStyles.subHeaderText}>{leftText}</Text>
      </View>
      <ColumnLabels labels={labels} />
    </View>
  )
}
